module.exports = __webpack_public_path__ + "static/media/ips.900284b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/ips.png
// module id = 455
// module chunks = 0